export default {
  settings: {
    mailcustom: "Personnalisation de l'envoi d'e-mail",
    profil: 'Profil utilisateur'
  },
  ok: 'Ok',
  invalidatedCalcul: '',
  Conditions: 'Conditions',
  MentionsLegales: 'Mentions Légales',
  ContactUs: 'Nous Contacter',
  About: 'À propos',
  Error: 'Erreur',
  Password: 'Mot de passe',
  Firstname: 'Prénom',
  Lastname: 'Nom',
  Invalide: 'Invalid',
  Close: 'Fermer',
  Thanks: 'Merci',
  Mail: 'E-mail',
  unknown_error: 'Erreur Inconnu :',
  GeneratingPDF: 'Generation du Pdf en cours',
  PleaseWait: 'Veuillez patienter',
  Loading: 'Chargement...',
  Information: 'Information', // use for alert message,
  Success: 'Succès', // use for alert
  UnknownError: 'Une erreur inconnu est arrivée, vérifiez votre connexion ou contactez le support.',
  Sections: 'Sections',
  Recherche: 'Recherche',
  Cancel: 'Annuler',
  Reject: 'Refuser',
  subscribe: "S'abonner",
  disconnect: 'Se déconnecter',
  confirm: 'Confirmation',
  delete: 'Supprimer',
  // callout pression
  pression_touchAssist: "Cliquez pour l'assistant",
  TouchForValiation: 'Toucher pour valider',
  PressionAtmoEstimate: 'Pression estimée : ',
  Connectionrequired: 'Une connection internet est requise.',
  // action button
  // mail
  mail: {
    action: 'Envoyer par e-mail'
  },
  disclosure_button: 'Aide au calcul',
  TODO: 'A CODER OU A DEFINIR DANS LA SPEC',
  // Backup
  backup_title: 'Sauvegarder votre calcul pour y accéder plus tard',
  backup_offer: "L'enregistrement et le chargement des calculs est une fonctionnalité premium.",
  backup_name: 'Nom de la sauvegarde',
  backup_nameFill: 'Saississez un nom de sauvegarde',
  backup_replace: 'Remplacer',
  backup_save: 'Sauvegarder',
  backupsave_title: 'Sauvegarde',
  backup_warning: 'Une sauvegarde existe dejà avec ce nom, souhaitez vous la remplacer ?',
  backup_success: 'Votre calcul a bien été sauvegardé.',
  backup_delete: 'Effacer',
  backup_load: 'Charger',
  backup_premium1: 'Abonnement requis',
  select_item: 'Choissisez un élément...',
  // custom or test
  I1337TestPremium: 'Test Premium forbidden',
  S00TEST: 'test section',

  year: 'an',
  years: 'ans',
  month: 'mois',
  months: 'mois',
  weeks: 'semaines',
  week: 'semaine',
  days: 'jours',
  day: 'jour',
  hours: 'heures',
  hour: 'heure',
  minutes: 'minutes',
  miniute: 'minute',
  seconds: 'secondes',
  second: 'seconde',

  currency: 'value {{value, currency}}'
}
